import axios, { AxiosResponse } from 'axios';
import {
  APIKEY_GOOGLE,
  API_GOOGLE_GEOCODE_URL, API_URL_GATEWAY_AEREO, API_URL_INTEGRACAO_VOALA
} from 'constants/constants';
import { IAirportAroundRQ } from 'models/airport/IAirportAroundRQ';
import { IAirportAroundRS } from 'models/airport/IAirportAroundRS';
import { ISearchAirportsRQ } from 'models/airport/ISearchAirportsRQ';
import { IApiRS } from 'models/api/IApiRS';
import { ICarroCompletoDisponibilidadeRS } from 'models/car/ICarroCompletoDisponibilidadeRS';
import { ICarroCompletoTarifarRQ } from 'models/car/ICarroCompletoTarifarRQ';
import { Aeroporto } from 'models/flight/IDisponibilidadeAerea';
import { BlogPostRS } from 'models/others/BlogPostRS';
import { IFaqRS } from 'models/others/IFaqRS';
import { IRecommendContentRS } from 'models/others/IRecommendContentRS';
import { IRecommendSingleContentRS } from 'models/others/IRecommendSingleContentRS';
import { IPacoteCompletoDisponibilidadeRQ } from 'models/package/IPacoteCompletoDisponibilidadeRQ';
import { IPacoteCompletoDisponibilidadeRS } from 'models/package/IPacoteCompletoDisponibilidadeRS';
import AuthService from 'services/AuthService';
import { ICmsProducts } from '../models/others/ICmsProducts';

let cancel;
const { CancelToken } = axios;
const api_integracao_voala = axios.create({
  baseURL: API_URL_INTEGRACAO_VOALA,
});
const api_url_aereo = axios.create({
  baseURL: API_URL_GATEWAY_AEREO,
});

const api_google_geocode = axios.create({ baseURL: API_GOOGLE_GEOCODE_URL });

function getToken(_api) {
  const Auth = new AuthService();
  const token = Auth.getToken();
  if (token) {
    _api.defaults.headers.common.Authorization = `Bearer ${token}`;
  }
}

function handleReturn(res: AxiosResponse<IApiRS>) {
  if (res.data.HasErrors) return Promise.reject(res.data.ReturnMessage);

  if (res.data.Data === false && res.data.Errors == null)
    return Promise.resolve(res.data.ReturnMessage);

  if (res.data.Data == null && res.data.Errors)
    return Promise.reject(res.data.ReturnMessage);

  if (res.data.Data == null && res.data.ReturnMessage.length > 0)
    return Promise.resolve(res.data.ReturnMessage);

  return Promise.resolve(res.data.Data);
}

function handleErrorReturn(err: any) {
  if (Array.isArray(err)) return Promise.reject(err);
  // eslint-disable-next-line
  return Promise.reject({
    statusCode: err.response.status,
    statusText: err.response.statusText,
  });
}

export interface ApiRequest<T> {
  dados: T;
}
export interface ApiResponse<T> {
  Data: T;
}

const ApiService = {
  user: {
    loginUser: data => api_integracao_voala.post('Logar', data),
    registerUser: data => api_integracao_voala.post('CadastrarUsuario', data),
    recoverPassword: data => api_integracao_voala.post('RedefinirSenha', data),
    changePassword: data => api_integracao_voala.post('AlterarSenha', data),
    changeEmail: data =>
      api_integracao_voala.post('AlterarEmail', data).then(res => handleReturn(res)),
    passwordReset: data =>
      api_integracao_voala
        .post('AlterarSenhaPorToken', data)
        .then(res => handleReturn(res)),
    validTokenPasswordReset: data =>
      api_integracao_voala.post('ValidarToken', data).then(res => handleReturn(res)),
    verificaPorToken: data =>
      api_integracao_voala
        .post('VerificaLoginToken', data)
        .then(res => handleReturn(res)),
    changeAddress: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('EnderecoPessoaCorporativo', data)
        .then(res => handleReturn(res));
    },
    searchOrders: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('BuscarPedido', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    detailOrder: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('BuscarPedidoDetalhado', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    getLinkVoucher: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('BuscarLinkVoucher', data)
        .then(res => handleReturn(res));
    },
    getPicture: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('ObtemFoto', data)
        .then(res => handleReturn(res));
    },
    updatePicture: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('AtualizarFoto', data)
        .then(res => handleReturn(res));
    },
    getUserData: () => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('BuscarPessoa')
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    cancelationOrder: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('EnviarEmailCancelamento', data)
        .then(res => handleReturn(res));
    },
    atualizarPessoa: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('AtualizarPessoa', data)
        .then(res => handleReturn(res));
    },
  },
  hotel: {
    reviews: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Hotel/Avaliacoes', data)
        .then(res => handleReturn(res));
    },
    details: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Hotel/Detalhes', data)
        .then(res => handleReturn(res));
    },
    disponibility: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Hotel/Disponibilidade', data)
        .then(res => handleReturn(res));
    },
    disponibilityV2: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('v2/hotel/disponibilidade', data)
        .then(res => handleReturn(res));
    },
    confirmation: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Hotel/Confirmar', data)
        .then(res => handleReturn(res));
    },
    confirmationApartment: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Hotel/ConfirmaApartamento', data)
        .then(res => handleReturn(res));
    },
    confirmationHotel: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Hotel/ConfirmarHotel', data)
        .then(res => handleReturn(res));
    },
    getHotelConfirmation: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .get(`Hotel/BuscaHotelConfirmado/${data}`)
        .then(res => handleReturn(res));
    },
    reservation: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Hotel/Reservar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
  },
  flight: {
    searchAirports: (data: ApiRequest<ISearchAirportsRQ>): Promise<Aeroporto[]> => {
      delete api_integracao_voala.defaults.headers.common.Authorization;
      return api_integracao_voala
        .post('Aereo/BuscarAeroportos', data)
        .then(res => handleReturn(res));
    },
    listFlightsForPackage: data => {
      delete api_integracao_voala.defaults.headers.common.Authorization;
      return api_integracao_voala
        .post('Aereo/DisponibilidadePacote', data)
        .then(res => handleReturn(res));
    },
    listFlights: data => {
      delete api_integracao_voala.defaults.headers.common.Authorization;
      return api_integracao_voala
        .post('Aereo/Disponibilidade', data)
        .then(res => handleReturn(res));
    },
    loadFlightDetails: data => {
      delete api_integracao_voala.defaults.headers.common.Authorization;
      return api_integracao_voala
        .post('Aereo/Tarifar', data)
        .then(res => handleReturn(res));
    },
    loadFlightReservation: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Aereo/Reservar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadFlightInstallmentOptions: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Aereo/Parcelar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadFlightIssuePayment: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Aereo/Emitir', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadFlightAntiFrude: data => {
      getToken(api_url_aereo);
      return api_url_aereo
        .post('', data)
        .then(res => Promise.resolve(res))
        .catch(err => handleErrorReturn(err));
    },
  },
  package: {
    loadPackageInstallmentOptions: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Pacote/Parcelar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadPackageInstallmentOptionSelected: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Pacote/EscolhaParcelamento', data)
        .then(res => handleReturn(res));
    },
    loadPackageIssuePayment: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Pacote/Reservar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
  },
  completePackage: {
    loadPackageAvailability: (
      data: ApiRequest<IPacoteCompletoDisponibilidadeRQ>,
    ): Promise<IPacoteCompletoDisponibilidadeRS> => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('PacoteCompleto/Disponibilidade', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadHospedagemAvailability: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('HotelCompleto/Disponibilidade', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadFlightTariff: (data): Promise<IPacoteCompletoDisponibilidadeRS> => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('PacoteCompleto/Aereo/Tarifar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadHospedagemTariff: (data): Promise<IPacoteCompletoDisponibilidadeRS> => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('HotelCompleto/Tarifar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadHospedagemPacoteTariff: (
      data,
    ): Promise<IPacoteCompletoDisponibilidadeRS> => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('PacoteCompleto/Hotel/Tarifar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadPackageCarTarrif: (
      data: ApiRequest<ICarroCompletoTarifarRQ>,
    ): Promise<IPacoteCompletoDisponibilidadeRS> => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('PacoteCompleto/Carro/Tarifar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
  },
  car: {
    loadCarAvailabilityOffer: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('CarroCompleto/Disponibilidade', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadCarTarrifOffer: (
      data: ApiRequest<ICarroCompletoTarifarRQ>,
    ): Promise<ICarroCompletoDisponibilidadeRS> => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('CarroCompleto/Tarifar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadCarAvailability: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Carro/Disponibilidade', data)
        .then(res => handleReturn(res));
    },
    loadCarDetail: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Carro/Detalhe', data)
        .then(res => handleReturn(res));
    },
    loadCarTariff: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Carro/Tarifar', data)
        .then(res => handleReturn(res));
    },
    loadCarInstallmentOptions: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Carro/Parcelamento', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadCarReservation: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Carro/Reservar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
  },
  insurance: {
    loadInsuranceAvailability: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Seguro/Disponibilidade', data)
        .then(res => handleReturn(res));
    },
    loadInsuranceDetail: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Seguro/Tarifar', data)
        .then(res => handleReturn(res));
    },
    loadInsuranceInstallmentOptions: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Seguro/Parcelamento', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadInsuranceReservation: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Seguro/Reservar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
  },
  sharedReservation: {
    loadReservationShared: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('ReservaCompartilhada/Reservar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadReservationCarShared: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('CarroReservaCompartilhada/Reservar', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadPaymentShared: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('ReservaCompartilhada/PagamentoReserva', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadValidatePayer: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('ReservaCompartilhada/ValidaPagante', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadAddPayments: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('ReservaCompartilhada/AdicionaPagantes', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
    loadSendLembrete: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('ReservaCompartilhada/EnviarLembrete', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
  },
  sharedLink: {
    loadSharedHotelPayment: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Compartilhamento/GeraLinkCompartilhamento', data)
        .then(res => handleReturn(res));
    },
    loadDetailSharedHotel: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Compartilhamento/DisponibilidadeHotel', data)
        .then(res => handleReturn(res));
    },
    loadSharedPackage: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Compartilhamento/GeraLinkCompartilhamentoPacote', data)
        .then(res => handleReturn(res));
    },
    loadSharedPackageReview: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Compartilhamento/ReviewCompartilhamentoPacote', data)
        .then(res => handleReturn(res));
    },
    loadSharedFlight: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Compartilhamento/GeraLinkCompartilhamentoAereo', data)
        .then(res => handleReturn(res));
    },
    loadSharedFlightAvailability: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Compartilhamento/DisponibilidadeAereo', data)
        .then(res => handleReturn(res));
    },
  },
  others: {
    searchCities: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('BuscarCidade', data)
        .then(res => handleReturn(res));
    },
    searchLocalities: data => {
      if (cancel !== undefined) {
        cancel();
      }
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('BuscarLocalidade', data, {
          cancelToken: new CancelToken(function executor(c) {
            cancel = c;
          }),
        })
        .then(res => handleReturn(res));
    },
    detailLocality: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('DetalharLocalidade', data)
        .then(res => handleReturn(res));
    },
    loadInstallmentOptions: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Pagamento/Parcelar', data)
        .then(res => handleReturn(res));
    },
    obtemOferta: () => api_integracao_voala.get('ObtemOfertas'),
    loadFaq: (): Promise<IFaqRS> =>
      api_integracao_voala
        .get('Painel/ListarFaq')
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err)),
    loadRecommendContent: (): Promise<IRecommendContentRS[]> =>
      api_integracao_voala
        .get('ConteudoRecomenda/ListarConteudo')
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err)),
    loadRecommendContentBySlug: (
      slugName: string,
    ): Promise<IRecommendSingleContentRS> =>
      api_integracao_voala
        .get(`ConteudoRecomenda/ListarConteudoPorSlug?slugName=${slugName}`)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err)),
  },
  consultaCep: {
    getCep: async data => {
      delete api_integracao_voala.defaults.headers.common.Authorization;
      return api_integracao_voala
        .post('ConsultaCEP', data)
        .then(res => handleReturn(res));
    },
  },
  verificarSeEmailExiste: {
    getEmail: async data => {
      delete api_integracao_voala.defaults.headers.common.Authorization;
      return api_integracao_voala
        .post('VerificarSeEmailExiste', { Dados: data })
        .then(res => handleReturn(res));
    },
  },
  painel: {
    getBanners: data => {
      return api_integracao_voala
        .post('Painel/ListarBanner', data)
        .then(res => handleReturn(res));
    },
  },
  pagamento: {
    validarPagamento: data => {
      return api_integracao_voala
        .post('Pagamento/ValidaPromocao', data)
        .then(res => handleReturn(res));
    },
    validaCupomDesconto: data => {
      return api_integracao_voala
        .post('Pagamento/ValidaCupomDesconto', data)
        .then(res => handleReturn(res));
    },
  },
  google: {
    retornaNomeCidade: data => {
      return api_google_geocode.get(
        `json?latlng=${data.latitude},${data.longitude}&key=${APIKEY_GOOGLE}`,
      );
    },
  },
  alerta: {
    marcarComoLido: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Alerta/MarcarComoLido', data)
        .then(res => handleReturn(res));
    },
  },
  carrossel: {
    obter: (typeProduct: ICmsProducts) => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .get(`Carrossel/Obter?produto=${typeProduct}`)
        .then(res => handleReturn(res));
    },
  },
  posts: {
    obter: (): Promise<BlogPostRS[]> => {
      getToken(api_integracao_voala);
      return api_integracao_voala.get(`Blog/Posts`).then(res => handleReturn(res));
    },
  },
  popup: {
    get: (typeProduct: ICmsProducts) => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .get(`Banner/ObterPopup?produto=${typeProduct}`)
        .then(res => handleReturn(res));
    }
  },
  banner: {
    obter: (typeProduct: ICmsProducts) => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .get(`Banner/Obter?produto=${typeProduct}`)
        .then(res => handleReturn(res));
    },
  },
  airport: {
    searchAirportAround: (
      data: ApiRequest<IAirportAroundRQ>,
    ): Promise<IAirportAroundRS> => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Aeroporto/BuscarAeroportosProximos', data)
        .then(res => handleReturn(res))
        .catch(err => handleErrorReturn(err));
    },
  },
  avaliacoes: {
    buscar: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Avaliacoes/Obter', data)
        .then(res => handleReturn(res));
    },
  },
  conversions: {
    newsletter: data => {
      getToken(api_integracao_voala);
      return api_integracao_voala
        .post('Conversao/Newsletter', data)
        .then(res => handleReturn(res));
    },
  },
};

export default ApiService;
